import { render, staticRenderFns } from "./ItemListView.vue?vue&type=template&id=b9b9b1ca&scoped=true"
import script from "./ItemListView.vue?vue&type=script&lang=js"
export * from "./ItemListView.vue?vue&type=script&lang=js"
import style0 from "./ItemListView.vue?vue&type=style&index=0&id=b9b9b1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b9b1ca",
  null
  
)

export default component.exports